import React from 'react'

const EczodexGroup = () => {
  return (
        <section>
      <p>
        Eczodex Group Ltd Eczodex Group Ltd is the technology platform operator
        responsible for the design, development, and administration of the USCY
        stablecoin infrastructure and the broader system architecture.
        Responsibilities Platform engineering Vault accounting logic Queue
        management systems API interfaces and onboarding flows Risk and control
        frameworks Integration with the MSB issuer and trust What Eczodex Does
        Not Do Does not issue tokens (Brale does) Does not custody client funds
        (Northern Trust does) Does not control the YPP supply (YPP Foundation
        does) Does not own USCY reserves (USCY Reserves Trust does) Position in
        Architecture Eczodex is the technology and operational layer, ensuring
        correctness, security, and transparency across all system processes.
        Related Concepts USCY Digital Asset LLC USCY Reserves Trust YPP
        Foundation
      </p>
    </section>
  )
}

export default EczodexGroup